export default "__VITE_ASSET__227ccdfe__"